<template>
  <div class="failed">
     <img src="../../../assets/img/ziliao_err.png" alt="">
     <strong>Rejection message</strong>
      <p>Unfortunately, based on the information submitted by you, we are unable to proceed with<br/>
      your application. If you believe there were errors in the information provided, you can go<br/>
       back and change them and submit again. Upon rejection from us, should there be any<br/>
        change in your own circumstances, please feel free to contact us again. </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.failed {
  text-align: center;
  padding: 60px 0 150px;
  img {
    display: inline;
  }
  strong {
    display: block;
    font-size: 18px;
    line-height: 19px;
    color: #333333;
    margin: 25px auto 15px;
  }
  p {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #333333;
  }
}
</style>
